module.exports = "assets/b77eedcd84b388affed3c437d62b25a4.gif";